import { useListProjectLocationsQuery } from "@generated";
import { RootState } from "@reducers/rootReducer";
import { useSelector } from "react-redux";
import { Location } from "../types/Location";

interface UseListLocationsArgs {
  projectId: string;
  page?: { number?: number; size?: number };
}

const useListLocations = ({ projectId, page }: UseListLocationsArgs) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  const { data, error, isLoading, isFetching, refetch } =
    useListProjectLocationsQuery({
      slug: accountSlug,
      filter: { project: projectId },
      page: page || { size: 250 },
    });

  const locations: Location[] =
    data?.data?.map((loc: any) => ({
      id: String(loc.id),
      name: loc.attributes?.name || "",
      street: loc.attributes?.street || "",
      street2: loc.attributes?.street2 || "",
      city: loc.attributes?.city || "",
      state: loc.attributes?.state || "",
      postalCode: loc.attributes?.["postal-code"] || "",
      country: loc.attributes?.country || "",
      remote: loc.attributes?.remote ?? false,
      projectVariables: loc.attributes?.["project-variables"] || [],
    })) || [];

  const pageMeta = {
    pageCount: data?.meta?.["page-count"] || 1,
    recordCount: data?.meta?.["record-count"] || 0,
  };

  return {
    locations,
    locationsError: error,
    locationsLoading: isLoading,
    locationsFetching: isFetching,
    pageMeta,
    refetch,
  };
};

export default useListLocations;
